<template>
<div class="text-left h-auto p-2 font-medium text-warm-gray-600 space-y-1 bg-white shadow-xl rounded" style="z-index:99">
    <div class="flex">
        <div class="flex-grow font-semibold text-gray-700">
            <i class="fa fa-hospital-user"></i> 
            <span class='text-lg'> {{Language.PATIENT_DETAILS}} </span>
        </div>
        <div v-if='!showEdit' class='flex'>
            <button class='text-left' @click="showEditFunction()"> Edit </button>
        </div>  
    </div>
     <div class='flex space-x-1 ml-2'>
            {{firstName}}
            {{middleInitial}}
            {{lastName}}
        </div>
           <div class='flex space-x-1 ml-2'>
            {{birthdayDisplay}}
        </div>
    <span class='text-xs text-gray-800 break-all'> {{store.state.patientAddress}} </span>
    <hr />
    <div class="grid grid-cols-2 md:grid-cols-1">
        <div> 
            <div>
                <div v-if="showEdit">
                    <div class="mt-1" v-if="showAddress !== false">
                        <input v-model="patientAddress" type="text" name="patientAddress" id="patientAddress" class=" ring-indigo-500 ring-1 max-h-8 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 px-4 rounded" placeholder="xcty..." />
                    </div>
                    <div class="mt-1">
                        <label> First Name </label>
                        <input  v-model="firstName" type="text" name="firstName" id="firstName" class="ring-indigo-500 ring-1 max-h-8 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 px-4 rounded" placeholder="Jane" />
                    </div>
                </div>
                <div v-else>
                    <label class='text-xs text-gray-700'> {{Language.PATIENT_NAME_TITLE}} </label>
                    <div class='flex space-x-1 ml-2'>
                        <label class="text-xs sm:text-md"> {{firstName}} </label>
                        <label class="text-xs sm:text-md"> {{middleInitial}} </label>
                        <label class="text-xs sm:text-md"> {{lastName}} </label>
                    </div>
                </div>
            </div>
            
            <div>
                <div v-if="showEdit">
                    <div class="mt-2">
                        <label> Middle Initial </label>
                        <input v-model="middleInitial" type="text" name="middleInitial" id="middleInitial" class="ring-indigo-500 ring-1 max-h-8 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 px-4 rounded" placeholder="" />
                    </div>
                    <div class="mt-2">
                        <label> Last Name </label>
                        <input v-model="lastName" type="text" name="lastName" id="lastName" class="ring-indigo-500 ring-1 max-h-8 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 px-4 rounded" placeholder="Doe" />
                    </div>
                </div>
            </div>
        </div>
        <div class='col-span-2 md:col-span-1'>
            <div v-if="showEdit">
                <div class="pt-1">
                    <label class="text-xs sm:text-md"> Birthday </label>
                    <!-- <input v-model="birthday" type="date" name="birthday" id="birthday" class="max-h-8 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 px-4 rounded-full" placeholder="Doe" /> -->
                    <date-selection id="birthdaySelect" :selectedDateChanged="setBirthday" :startDay="day" :startMonthIndex="month" :startYear="year"></date-selection>
                </div>
            </div>
            <div v-else>
                <label class='text-xs text-gray-700'> {{Language.BIRTHDAY}} </label>
                <div> 
                <label class='text-xs ml-2 sm:text-md'> {{ birthdayDisplay}} </label>
                </div>
            </div>
        </div>

        <div v-if="includeIds">
            <div v-if="showEdit">
                <div class="pt-1">
                    <input v-model="stateID" type="text" name="stateID" id="stateID" class="max-h-8 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 px-4 rounded-full" placeholder="State ID or DL" />
                </div>
            </div>
            <div v-else>
                <label class='text-xs text-gray-700'> {{Language.STATE_ID}} </label>
                <div class='ml-2'> {{stateID ? stateID : "No State ID"}} </div>
            </div>
        </div>

        <div v-if="includeIds">
            <div v-if="showEdit">
                <div class="pt-1">
                    <input v-model="passportNumber" type="text" name="passportNumber" id="passportNumber" class="max-h-8 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 px-4 rounded-full" placeholder="Passport #" />
                </div>
            </div>
            <div v-else>
                <label class='text-xs text-gray-700'> {{Language.PASSPORT_NUMBER}} </label>
                <div class='ml-2'> {{passportNumber ? passportNumber : "No Passport Number"}} </div>
            </div>
        </div>

        
    </div>
    <div class="space-y-2 flex-1 w-full">
        <div v-if="showEdit" class='flex-grow'>
            <button @click="save" class="w-full h-10 text-lg bg-indigo-500 rounded text-white">Save</button>
        </div>
        <div v-if="showEdit" class='flex-grow'>
            <button @click="cancel" class="w-full h-10 text-md rounded text-red-800">Cancel</button>
        </div>
       
        </div>
</div>
</template>

<script>
import {  ref, reactive, toRefs } from 'vue'
import {useStore} from "vuex";
import Language from "./../../../constants/language/english.js"
import DateSelection from "./DateSelection.vue";
export default {
  components: {DateSelection },
    setup () {
        const store = useStore();
        let patientAddress = new ref(store.state.patientAddress)
        console.log("PatientBirthday is of type:", typeof(store.state.patientBirthday))
        let split_date = store.state.patientBirthday === null ? [] : store.state.patientBirthday.split('T')[0].split('-');
        console.log(split_date)
        let _date = new Date(split_date[0],  split_date[1] -1, split_date[2])
        console.log(_date);
        let _birthday = _date;
        const state = reactive({
            //patientAddress: store.state.patientAddress,
            firstName: store.state.patientFirstName,
            middleInitial: store.state.patientMiddleInitial,
            lastName: store.state.patientLastName,
            birthday: _birthday,
            stateID: store.state.patientStateID,
            passportNumber: store.state.patientPassportNumber,
            day: parseInt(_date.getDate()),
            month :  parseInt(_date.getMonth()),
            year  :  parseInt(_date.getFullYear())
        })
        console.log("State at details form:", state)
        return {
            patientAddress,
            Language,
            ...toRefs(state),
        }
    },
    mounted(){

    },
    methods:{
        async save(){
            if(this.isValid()){
                let details = {};
                details.address = this.patientAddress;
                details.firstName = this.firstName;
                details.middleInitial = this.middleInitial;
                details.lastName = this.lastName;
                details.birthday = this.birthday;
                details.stateID = this.stateID;
                details.passportNumber = this.passportNumber;
                await this.savePatientInfo(details);
                this.$emit('patient-saved');

            }
            else {alert("Please fill out all the required information");}
        },
        cancel(){
            this.close();
        },
        isValid(){
            let valid = true; 
            if(this.firstName === "" || !this.firstName){valid = false}
            //if(this.middleInitial === "" || !this.middleInitial){valid = false}
            if(this.lastName === "" || !this.lastName){valid = false}
            console.log(this.birthday);
            if(this.birthday === "" || !this.birthday){valid = false}
            return valid;
        },
        setBirthday(date){
            this.birthday = date;
            this.$store.commit("setPatientBirthday", date);
        }
    },
    computed:{
        showEdit(){
            if(this.edit){
                return true
            }
            return false;
        },
        store(){
            return this.$store
        },
        birthdayDisplay(){
            if(this.birthday === "") return "";
            else{
                try{
                  
                    return this.birthday.toLocaleDateString('EN-US');
                }catch(err){console.log(this.birthday, err); return "err"}
            }
        }
    },
    props:["edit", "savePatientInfo", "showEditFunction", "close", "includeIds", "showAddress", "patientDetails"]
}
</script>

<style  scoped>

</style>